import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

/*
預計：
index before signin
signin
signup
forget password
reset password
 - finish stage
 - fail stage
email verify success /fail
riding strategy (upload)
strategy history

*/

const routes = [
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '/',
    name: 'home',
    meta: {
      layout: 'default',
      requiresAuth: false
    },
    component: () => import('@/views/basic/Index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      layout: 'default',
      requiresAuth: false
    },
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/basic', // 1 基本資料展示
    name: 'basic',
    meta: {
      layout: 'default',
      requiresAuth: false
    },
    component: () => import('@/views/basic/Index.vue')
  },
  {
    path: '/inspection', // 2 巡檢填報
    name: 'inspection',
    meta: {
      layout: 'default',
      requiresAuth: false
    },
    component: () => import('@/views/inspection/Index.vue')
  },
  {
    path: '/inspection/report', // 2.1 填報模組
    name: 'report',
    component: () => import('@/views/inspection/report/Index.vue')
  },
  {
    path: '/inspection/report/inspect', // 2.1.1 巡檢表單
    name: 'inspect',
    component: () => import('@/views/inspection/report/inspect/Index.vue')
  },
  {
    path: '/inspection/report/inspect/daily', // 2.1.1.1 每日巡檢
    name: 'inspectDaily',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/AnoxicPool.vue')
  },
  {
    path: '/inspection/report/inspect/daily/anoxicPool', // 2.1.1.1.1 缺氧池
    name: 'anoxicPool',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/AnoxicPool.vue')
  },
  {
    path: '/inspection/report/inspect/daily/bioProcessUnit', // 2.1.1.1.2 生物處理單元 (初沉池)
    name: 'bioProcessUnit',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/BioProcessUnit.vue')
  },
  {
    path: '/inspection/report/inspect/daily/preprocessUnit', // 2.1.1.1.3 前處理單元
    name: 'preprocessUnit',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/PreprocessUnit.vue')
  },
  {
    path: '/inspection/report/inspect/daily/disinfectionPool', // 2.1.1.1.4 消毒池
    name: 'dailyDisinfectionPool',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/DisinfectionPool.vue')
  },
  {
    path: '/inspection/report/inspect/daily/sludgeRoom', // 2.1.1.1.5 污泥機房
    name: 'dailySludgeRoom',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/SludgeRoom.vue')
  },
  {
    path: '/inspection/report/inspect/daily/waterPumpingStation', // 2.1.1.1.6 進流抽水站
    name: 'waterPumpingStation',
    component: () => import('@/views/inspection/report/inspect/inspectDaily/WaterPumpingStation.vue')
  },
  {
    path: '/inspection/report/inspect/area', // 2.1.1.2 區域巡檢
    name: 'inspectArea',
    component: () => import('@/views/inspection/report/inspect/inspectArea/Index.vue')
  },
  {
    path: '/inspection/report/inspect/area/biologicalPool', // 2.1.1.2.1 生物池
    name: 'biologicalPool',
    component: () => import('@/views/inspection/report/inspect/inspectArea/BiologicalPool.vue')
  },
  {
    path: '/inspection/report/inspect/area/blowerRoom', // 2.1.1.2.2 鼓風機房
    name: 'blowerRoom',
    component: () => import('@/views/inspection/report/inspect/inspectArea/BlowerRoom.vue')
  },
  {
    path: '/inspection/report/inspect/area/intakeStation', // 2.1.1.2.3 進抽站
    name: 'intakeStation',
    component: () => import('@/views/inspection/report/inspect/inspectArea/IntakeStation.vue')
  },
  {
    path: '/inspection/report/inspect/area/preprocess', // 2.1.1.2.4 前處理
    name: 'preprocess',
    component: () => import('@/views/inspection/report/inspect/inspectArea/Preprocess.vue')
  },
  {
    path: '/inspection/report/inspect/area/primaryPond', // 2.1.1.2.5 初沉池
    name: 'primaryPond',
    component: () => import('@/views/inspection/report/inspect/inspectArea/PrimaryPond.vue')
  },
  {
    path: '/inspection/report/inspect/area/secondaryPond', // 2.1.1.2.6 二沉池
    name: 'secondaryPond',
    component: () => import('@/views/inspection/report/inspect/inspectArea/SecondaryPond.vue')
  },
  {
    path: '/inspection/report/inspect/area/disinfectionPool', // 2.1.1.2.7 消毒流放池
    name: 'disinfectionPool',
    component: () => import('@/views/inspection/report/inspect/inspectArea/DisinfectionPool.vue')
  },
  {
    path: '/inspection/report/inspect/area/sludgeRoom', // 2.1.1.2.8 污泥機房
    name: 'sludgeRoom',
    component: () => import('@/views/inspection/report/inspect/inspectArea/SludgeRoom.vue')
  },
  {
    path: '/inspection/report/inspect/equip/:id', // 2.1.1.3 設備巡檢
    name: 'inspectEquip',
    component: () => import('@/views/inspection/report/inspect/inspectEquip/Index.vue')
  },
  {
    path: '/inspection/report/inspect/qrcode', // 2.1.1.4 QRcode掃描
    name: 'inspectQrcode',
    component: () => import('@/views/inspection/report/inspect/inspectQrcode/Index.vue')
  },
  {
    path: '/inspection/report/dosage', // 2.1.2 用藥量
    name: 'dosage',
    component: () => import('@/views/inspection/report/dosage/Index.vue')
  },
  {
    path: '/inspection/report/sludge', // 2.1.3 污泥清運
    name: 'sludge',
    component: () => import('@/views/inspection/report/sludge/Index.vue')
  },
  {
    path: '/inspection/report/water', // 2.1.4 水質數據
    name: 'water',
    component: () => import('@/views/inspection/report/water/Index.vue')
  },
  {
    path: '/inspection/search', // 2.2 查詢模組
    name: 'search',
    meta: {
      layout: 'default',
      requiresAuth: false
    },
    component: () => import('@/views/inspection/search/Index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// TODO: add auth check, logout, store...
export default router
